function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useAlert, useConfirm, usePrompt } from '../hooks/useAlertDialog';
import { jsx as ___EmotionJSX } from "@emotion/react";
export function withAlert(Component) {
  return function WithAlert(props) {
    const alert = useAlert();
    return ___EmotionJSX(Component, _extends({}, props, {
      alert: alert
    }));
  };
}
export function withConfirm(Component) {
  return function WithConfirm(props) {
    const confirm = useConfirm();
    return ___EmotionJSX(Component, _extends({}, props, {
      confirm: confirm
    }));
  };
}
export function withPrompt(Component) {
  return function WithPrompt(props) {
    const prompt = usePrompt();
    return ___EmotionJSX(Component, _extends({}, props, {
      prompt: prompt
    }));
  };
}